import React from 'react';
import AllCards from '../features/cards';

const AllCardsPage = () => {
  return <AllCards />;
};

export default AllCardsPage;
